module.exports = __webpack_public_path__ + "static/media/art-gear.19fd92d1.png";